import { isAdsTerraEnabled } from '@/utils/adnetwork';
import { useEffect, useRef } from 'react';

interface AdsterraNativeBannerProps {
  className?: string;
}

export function AdsterraNativeBanner({ className = '' }: AdsterraNativeBannerProps) {
  const adContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isAdsTerraEnabled) return;

    const currentContainer = adContainerRef.current;
    if (!currentContainer) return;

    // Clear previous contents if re-mounting
    currentContainer.innerHTML = '';

    // Create the Adsterra container div
    const containerDiv = document.createElement('div');
    containerDiv.id = 'container-e5a4a8929df2b2af602d63e764906fc7';
    currentContainer.appendChild(containerDiv);

    // Create and append the Adsterra invoke script
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    script.src = 'https://pl31530285.profitableratecpmnetwork.com/e5a4a8929df2b2af602d63e764906fc7/invoke.js';
    currentContainer.appendChild(script);

    return () => {
      if (currentContainer) {
        currentContainer.innerHTML = '';
      }
    };
  }, []);

  if (!isAdsTerraEnabled) {
    return null;
  }

  return (
    <div className={`w-full my-8 text-center ${className}`}>
      <div className="inline-block w-full max-w-5xl overflow-hidden rounded-2xl border border-border/50 bg-card/40 p-3 sm:p-4 shadow-sm backdrop-blur-sm">
        <div className="flex items-center justify-between pb-2 mb-2 border-b border-border/30 px-1">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/70">
            Sponsored / Advertisement
          </span>
        </div>
        <div ref={adContainerRef} className="min-h-[90px] flex items-center justify-center" />
      </div>
    </div>
  );
}
